export default __webpack_public_path__ + "static/media/aura.db7cfab6.md";